<p-dialog header="{{ header }}" [(visible)]="displayNewEmail" [modal]="true" [responsive]="true" (onHide)="cancel()" [style]="{ width: '45vw' }">
    <form [formGroup]="emailForm">
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-1">
                    <div class="p-mt-2"> From </div>
                </div>
                <div class="p-col-11">
                    <p-dropdown [options]="allVendorSMTP" optionLabel="emailId" appendTo="body" [filter]="true" formControlName="emailFrom" 
                        [ngModelOptions]="{ standalone: true }" (onChange)="onChangeEmailFrom()"> 
                    </p-dropdown>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-lg-1">
                    <label>To </label>
                </div>
                <div class="p-col-12 p-lg-11">
                    <span class="p-input-icon-right" [ngClass]="{ 'p-invalid': toAutocomplete.invalid && (toAutocomplete.touched || toAutocomplete.dirty) }">
                        <i class="p-text-normal">
                            <button pButton class="p-button-text" (click)="onClickShowCc()" label="Cc" style="padding-right: 1rem"></button>
                            <button pButton class="p-button-text" (click)="onClickShowBcc()" label="Bcc"></button>
                        </i>
                        <p-autoComplete field="emailAddress" [required]="true" name="toRecipients" id="toRecips" #toAutocomplete="ngModel" 
                            [(ngModel)]="toRecipients" [suggestions]="emailList" [completeOnFocus]="true" [ngModelOptions]="{ standalone: true }" 
                            ngDefaultControl [multiple]="true" (onKeyUp)="onKeyUp($event, 'to')" (keydown)="onToKeyDown($event, 'tocc')" 
                            (completeMethod)="emailListDropdown($event.query)" (onBlur)="onBlur($event, 'to')">
                            <ng-template let-toRecip pTemplate="item">
                                <ng-container *ngIf="toRecip.name">
                                    {{ toRecip.name + "<" + toRecip.emailAddress + ">" }}
                                </ng-container>
                            </ng-template>
                        </p-autoComplete>
                    </span>
                    <small *ngIf="toRecipients.length < 1 && (toAutocomplete.touched || toAutocomplete.dirty)" class="p-invalid">At least one recipient is required</small>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid" *ngIf="showCc">
                <div class="p-col-12 p-lg-1">
                    <label>Cc</label>
                </div>
                <div class="p-col-12 p-lg-11">
                    <p-autoComplete field="emailAddress" name="ccRecipients" #bccAutocomplete [(ngModel)]="ccRecipients" 
                        [suggestions]="emailList" [completeOnFocus]="true" [ngModelOptions]="{ standalone: true }" [multiple]="true" 
                        (onKeyUp)="onKeyUp($event, 'tocc')" (keydown)="onToKeyDown($event, 'tocc')" (completeMethod)="emailListDropdown($event.query)" 
                        required="true" (onBlur)="onBlur($event, 'tocc')">
                        <ng-template let-ccRecip pTemplate="item">
                            <ng-container *ngIf="ccRecip.name">
                                {{ ccRecip.name + "<" + ccRecip.emailAddress + ">" }}
                            </ng-container>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid" *ngIf="showBcc">
                <div class="p-col-12 p-lg-1">
                    <label>Bcc</label>
                </div>
                <div class="p-col-12 p-lg-11">
                    <p-autoComplete field="emailAddress" name="bccRecipients" #bccAutocomplete [(ngModel)]="bccRecipients" 
                        [suggestions]="emailList" [completeOnFocus]="true" [ngModelOptions]="{ standalone: true }" [multiple]="true" 
                        (onKeyUp)="onKeyUp($event, 'bcc')" (keydown)="onToKeyDown($event, 'tocc')" (completeMethod)="emailListDropdown($event.query)" 
                        (onBlur)="onBlur($event, 'bcc')">
                        <ng-template let-bccRecip pTemplate="item">
                            <ng-container *ngIf="bccRecip.name">
                                {{ bccRecip.name + "<" + bccRecip.emailAddress + ">" }}
                            </ng-container>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-1">
                    <div class="p-mt-2"> Subject </div>
                </div>
                <div class="p-col-11">
                    <input type="text" pInputText formControlName="subject" />
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <label>Body <span style="color: red">*</span></label>
                    <p-editor #editor placeholder="Add your message..." [style]="{ height: '220px' }" formControlName="content"></p-editor>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid" *ngIf="emailAttachments && emailAttachments?.length">
                <div class="p-pb-2">
                    <div class="attachments-container">
                        <div class="p-chips">
                            <ul class="p-chips-multiple-container">
                                <ng-container *ngFor="let attachment of emailAttachments; let i = index">
                                    <li class="p-chips-token">
                                        <ng-container>
                                            <span class="p-chips-token-label">
                                                {{ attachment?.name }}
                                            </span>
                                        </ng-container>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton label="Send" (click)="sendEmail()" [disabled]="!toRecipients.length || emailForm.get('emailFrom').invalid || emailForm.get('subject').invalid"></button>
    </p-footer>
</p-dialog>
